import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import axios from 'axios';
import { url } from '../../weburl';
import CountryContext from '../country_context';
import { BeatLoader } from 'react-spinners';
import Swal from 'sweetalert2';
export const SupplyPhoneNumberDialog = (props) => {

    const context = useContext(CountryContext)
    const [phoneNumber, setPhoneNumber] = useState()
    const [modalResponse, setModalResponse] = useState()
    const [open, setOpen] = useState(props.open)
    const handleClose = () => {

    }

    const handleChange = (e) => {
        setPhoneNumber(e.target.value)
    }

    const supplyPhoneNumber = () => {
        axios
        .post(`${url}api/users/${context.user_sql_details.id}`, {phone_number: phoneNumber})
        .then((res)=> {
            setModalResponse(res.data.message)
            console.log(res)
            setOpen(false)
            Swal.fire('Updated!', '', 'success')


        })
        .catch((err)=> {
            console.log(err)
        })
    }
    return (

       <div>
            {context.user_sql_details ? 
               <Dialog
               onClose={handleClose}
               aria-labelledby="customized-dialog-title"
               open={open}
           >
   
               <DialogContent dividers>
                   <div className="row align-items-center justify-content-center  ">
   
                       <div className="px-4 mx-sm-0 text-center text-md-left">
   
                           <h5 className="mb-5 mt-2">Please supply your phone number before proceeding.</h5>
   
                           <div className='row align-items-center'>
                               <div className='col-md-4'><label className='text-dark' for="phoneNumber">PHONE NUMBER</label></div>
                               <div class="col-md-6 ">
   
   
                                   <input name='afbr_no'
                                       type="number" class="form-control" 
                                       // value={''}
                                       onChange={e => handleChange(e)}
                                       id="phoneNumber" placeholder="phone number"></input>
                               </div>
                           </div>
   
                       </div>
                   </div>
               </DialogContent>
               <DialogActions>
                   <Button autoFocus onClick={supplyPhoneNumber}>
                      SAVE
                   </Button>
               </DialogActions>
           </Dialog>
            : 
       <div className='p-5 bg-white'> <BeatLoader/></div>
        
        }
       </div>
     
    )
}